import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Box, styled } from "@mui/material";
import HeaderV2 from "../../componentsPeopletech/v2/HeaderV2";
import BarraApp from "../../componentsPeopletech/Barraaps";
import ServicesCirclesV2 from "../../componentsPeopletech/v2/ServicesCirclesV2";
import BookingCtaSectionV2 from "../../componentsPeopletech/v2/BookingCtaSectionV2";
import Footer from "../../componentsPeopletech/Footer/Footer";
import ContactSectionV2 from "../../componentsPeopletech/v2/ContactSectionV2";

const BASE_PATH = '/peoplefortech/v2';

const HomePeopleV2 = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || 'en';
  const baseUrl = 'https://www.peoplefortech.com';
  const v2Url = `${baseUrl}${BASE_PATH}`;

  const BackgroundVideoContainer = styled(Box)({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
    overflow: 'hidden',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      zIndex: 1,
    },
  });

  const Video = styled('video')({
    position: 'absolute',
    top: '50%',
    left: '50%',
    minWidth: '100%',
    minHeight: '100%',
    width: 'auto',
    height: 'auto',
    transform: 'translate(-50%, -50%)',
    filter: 'blur(5px)',
    objectFit: 'cover',
    zIndex: 0,
    opacity: 1,
  });

  const ContentWrapper = styled(Box)({
    position: 'relative',
    zIndex: 1,
    backgroundColor: 'transparent',
  });

  return (
    <>
      <Helmet>
        <title>{t('v2.seo.homeTitle')}</title>
        <meta name="description" content={t('v2.seo.homeDescription')} />
        <meta name="keywords" content={t('v2.seo.homeKeywords')} />
        <meta name="author" content="PeopleForTech" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={v2Url} />
        <html lang={currentLang} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={v2Url} />
        <meta property="og:title" content={t('v2.seo.homeTitle')} />
        <meta property="og:description" content={t('v2.seo.homeDescription')} />
        <meta property="og:image" content={`${baseUrl}/og-image.jpg`} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={v2Url} />
        <meta property="twitter:title" content={t('v2.seo.homeTitle')} />
        <meta property="twitter:description" content={t('v2.seo.homeDescription')} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                "@id": `${baseUrl}/#organization`,
                "name": "PeopleForTech",
                "alternateName": ["PXT", "People For Tech"],
                "url": baseUrl,
                "description": t('v2.seo.homeDescription'),
                "knowsAbout": ["Asesoramiento IA", "AI Advisory", "Implementación IA", "AI Implementation", "Auditoría IA", "Roadmap IA"],
                "sameAs": ["https://www.linkedin.com/in/people-for-tech", "https://www.tiktok.com/@peoplefortech"],
                "contactPoint": {
                  "@type": "ContactPoint",
                  "contactType": "Customer Service",
                  "email": "contact@peoplefortech.com",
                  "availableLanguage": ["en", "es", "pt"]
                },
                "areaServed": [{ "@type": "Place", "name": "Spain" }, { "@type": "Place", "name": "Latin America" }]
              },
              {
                "@type": "WebSite",
                "@id": `${baseUrl}/#website`,
                "url": baseUrl,
                "name": "PeopleForTech - Asesoramiento e Implementación de IA",
                "description": t('v2.seo.homeDescription'),
                "publisher": { "@id": `${baseUrl}/#organization` }
              },
              {
                "@type": "Service",
                "name": "Asesoramiento en Inteligencia Artificial",
                "alternateName": ["Asesoramiento IA", "AI Advisory", "Consultoría IA"],
                "description": t('v2.services.consultory.description'),
                "provider": { "@id": `${baseUrl}/#organization` },
                "serviceType": ["AI Advisory", "AI Consulting", "Asesoramiento IA"],
                "areaServed": "Worldwide",
                "hasOfferCatalog": {
                  "@type": "OfferCatalog",
                  "name": "Servicios de Asesoramiento IA",
                  "itemListElement": [
                    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Auditoría IA" } },
                    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Roadmap IA" } },
                    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Casos reales" } }
                  ]
                }
              },
              {
                "@type": "Service",
                "name": "Implementación de IA",
                "description": t('v2.services.development.description'),
                "provider": { "@id": `${baseUrl}/#organization` }
              }
            ]
          })}
        </script>
      </Helmet>
      <BackgroundVideoContainer>
        <Video autoPlay loop muted playsInline src="/18192389-hd_1920_1080_60fps.mp4">
          Tu navegador no soporta la reproducción de videos.
        </Video>
      </BackgroundVideoContainer>
      <ContentWrapper>
        <BarraApp />
        <HeaderV2 />
        {/* <ServicesCirclesV2 /> */}
        <BookingCtaSectionV2 />
        <ContactSectionV2 />
        <Footer />
      </ContentWrapper>
    </>
  );
};

export default HomePeopleV2;
